import { Col } from 'antd';
import styled from 'styled-components';

export const TransactionTableContainerStyled = styled.div`
  .ant-pagination {
    margin-right: 10px;
  }
`;

export const DetailDrawerStyled = styled(Col)<{ $isMobile?: boolean; $isActive?: boolean }>`
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  padding: 30px 0 0;
  border-left: 1px solid #c7c6c7;
  transition: all 0.15s;
  transform: translateX(${({ $isActive }) => ($isActive ? '0' : '100%')});
  ${({ $isMobile }) =>
    $isMobile
      ? `
        position: absolute;
        z-index: 10;
        left: 0;
        top: 0;
      `
      : ''}
  .ant-drawer-close {
    top: 0;
    padding: 5px;
  }
  .fields-container {
    width: 100% !important;
    max-width: 100% !important;
  }
  .transaction-form-section-header {
    border: none;
  }
`;

export const DetailFormContainerStyled = styled.div`
  padding: 0 10px;
  overflow-y: auto;
  flex: 1 1 auto;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  & button {
    background: none;
    padding: 0;
    border: none;
    cursor: pointer;
  }
`;

export const RefNoStyled = styled.div`
  font-weight: 500;
  color: #2a7dda;
`;
